import { HelpEdge } from './HelpEdge'
import InsertEdge from './InsertEdge'

export const edgeTypes = {
  insert: InsertEdge,
  help: HelpEdge,
}
